<template>
    <v-col
        component="CharacterDetail"
        sm="12"
        md="4"
        class="left-column"
        :class="{
            'small-design': isSmall,
            'xs-design': this.$vuetify.breakpoint.xs,
            list: showList,
            filter: showFilter,
            blacklist: showBlacklist,
        }"
    >
        <v-row v-if="isSmall">
            <v-btn @click="toggleBlock('list')">Character list</v-btn>
            <v-btn @click="toggleBlock('filter')">Character filter</v-btn>
            <v-btn @click="toggleBlock('blacklist')">Character blacklist</v-btn>
        </v-row>
        <character-list />
        <character-filter />
        <character-blacklist />
    </v-col>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import draggable from 'vuedraggable';
import Mp3Player from '@/components/.global/Mp3Player.vue';
import CharacterList from '@/components/Project/Character/CharacterList.vue';
import CharacterFilter from '@/components/Project/Character/CharacterFilter.vue';
import CharacterBlacklist from '@/components/Project/BlackList/CharacterBlacklist.vue';

import { defaultCharacter } from '@/store/Admin/CharacterStore';

export default {
    name: 'CharacterDetail',

    components: {
        draggable,
        Mp3Player,
        CharacterList,
        CharacterFilter,
        CharacterBlacklist,
    },

    data() {
        return {
            fatalError: false,
            loading: true,
            showList: true,
            showFilter: true,
            showBlacklist: true,
            isSmall: false,
        };
    },

    async created() {
        this.isSmall = this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs;

        if (this.isSmall) {
            this.showList = false;
            this.showFilter = false;
            this.showBlacklist = false;
        }

        // Initial set of character
        if (this.project.characters.length > 0) {
            this.setCharacter(this.project.characters[0]);
        } else {
            this.setCharacter({ ...defaultCharacter });
        }
    },

    async mounted() {
        this.loading = false;
    },

    methods: {
        ...mapActions(['setCharacter']),

        toggleBlock(val = null) {
            if (val == 'list' && this.showList) {
                this.showList = false;
                return;
            }
            if (val == 'filter' && this.showFilter) {
                this.showFilter = false;
                return;
            }
            if (val == 'blacklist' && this.showBlacklist) {
                this.showBlacklist = false;
                return;
            }

            this.showList = false;
            this.showFilter = false;
            this.showBlacklist = false;
            if (val == 'list') this.showList = true;
            if (val == 'filter') this.showFilter = true;
            if (val == 'blacklist') this.showBlacklist = true;
        },
    },

    computed: {
        ...mapGetters({
            project: 'getProject',
        }),
    },

    watch: {
        ['$vuetify.breakpoint.sm'](val) {
            if (val || this.$vuetify.breakpoint.xs) {
                this.isSmall = true;
                this.showList = false;
                this.showFilter = false;
                this.showBlacklist = false;
            } else {
                this.isSmall = false;
                this.showList = true;
                this.showFilter = true;
                this.showBlacklist = true;
            }
        },
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

.slide-fade-enter-active {
    transition: all 0.3s ease;
}
.slide-fade-leave-active {
    transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
    transform: translateY(-10px);
    opacity: 0;
}

.v-card__title {
    padding: 0px 16px;
    font-size: 1rem;
    font-weight: bold;
}

.flip-list-move {
    transition: transform 0.5s;
}

.ghost {
    opacity: 0.5;
    background: #c8ebfb;
}

.selected {
    background: rgba(0, 0, 0, 0.1) !important;
}

[component='CharacterDetail'] {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .v-btn {
        color: inherit;
        background: inherit;
    }

    .row {
        margin: 0;
    }

    .v-card__title {
        font-size: 0.8rem;
        padding: 0 8px;
    }

    &.small-design {
        height: auto;
        justify-content: normal;
    }

    .v-list {
        overflow-y: auto;
    }

    .v-card__title {
        border-bottom: 1px solid;
    }

    .primary {
        background: linear-gradient(to bottom, @primary 0%, @primary_dk 100%) !important;
        color: #000 !important;
    }

    .accent {
        background: linear-gradient(to bottom, @accent 0%, @accent_dk 100%);
    }

    .warning {
        background: @warning;
    }

    .column-wrapper {
        margin: 0;

        & > .col {
            padding: 8px !important;
        }

        .v-card {
            display: flex;
            flex-direction: column;
        }
    }

    .character-create-form {
        margin-top: auto;
        position: relative;
        overflow: hidden;
        height: 55px;

        .v-input {
            padding: 0;
            margin: 0;
        }

        & > .v-btn,
        & > .row {
            transition: 500ms;
            margin: 8px;
            position: absolute;
        }

        & > .v-btn {
            left: 0%;
        }

        & > .row {
            left: 100%;
        }

        .col {
            padding: 0;

            .v-btn {
                height: auto;
                padding: 0 8px;
            }
        }
    }

    .creating {
        & > .v-btn {
            left: -100%;
        }

        & > .row {
            left: 0%;
        }
    }

    .left-column {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .v-card__title {
            font-size: 0.8rem;
            padding: 0 8px;
        }
    }

    .character-item {
        display: flex;
        min-height: 20px;

        .v-btn {
            margin-left: auto;
        }
    }

    .voices {
        height: 0;
        flex-grow: 1;
        overflow-y: scroll;
        flex-basis: 0;
    }

    .voice-item {
        min-height: 25px;
        padding: 0 8px;
    }

    .row {
        margin-left: 0;
        margin-right: 0;
    }

    .container {
        display: flex;
        flex-direction: row;
    }

    .v-input {
        input {
            border: none !important;
        }
    }
}
</style>

<style lang="less">
[component='CharacterDetail'] {
    &.small-design {
        overflow: hidden;
        & > .row {
            flex: 0;
        }
        & > .v-card {
            margin-top: 40px;
        }
        [component='CharacterList'],
        [component='CharacterFilter'],
        [component='CharacterBlacklist'] {
            height: fit-content;
            position: absolute;
            transition: all 0.5s ease;
            transform: translateY(-50%);
            pointer-events: none;
            width: 50%;
            opacity: 0;
            z-index: 30;
        }
        &.list {
            [component='CharacterList'] {
                transform: translateY(0%);
                pointer-events: auto;
                opacity: 100%;
            }
        }
        &.filter {
            [component='CharacterFilter'] {
                transform: translateY(0%);
                pointer-events: auto;
                opacity: 100%;
            }
        }
        &.blacklist {
            [component='CharacterBlacklist'] {
                transform: translateY(0%);
                pointer-events: auto;
                opacity: 100%;
            }
        }
    }

    &.xs-design {
        & > .row {
            .v-btn {
                width: 100%;
            }
        }
        & > .v-card {
            margin-top: 7.5rem;
        }
        [component='CharacterList'],
        [component='CharacterFilter'],
        [component='CharacterBlacklist'] {
            width: 100%;
        }
    }
}
</style>
